import { useSelector } from "react-redux";
import { Feature, isFeatureEnabled } from "global/config";
import type { RootModel } from "models/app";

export function useDesktopLyricsOpen(): boolean {
    const desktopLyricsOpen = useSelector((root: RootModel) => root.ui.layout.lyricsOpen);
    return !!desktopLyricsOpen && isFeatureEnabled(Feature.Lyrics);
}

